// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__iXa7u","savePackageButton":"ClientWallet_savePackageButton__bxpCt"};